import { MapTransliterationVariable } from '@src/data/UtmGenerator'

export function transliterationParameters(value: string): string {
  const ru = new Map(MapTransliterationVariable as [])

  const newValue = value.replace(/[ъь]+/g, '')

  /* eslint-disable*/
  // @ts-ignore
  return Array.from(newValue).reduce((s, l) => s + (ru.get(l) || (ru.get(l.toLowerCase()) === undefined && l) || ru.get(l.toLowerCase()).toUpperCase()), '')
}
